__turbopack_context__.v({
  "badge": "index-module-scss-module__4ObxUa__badge",
  "picture": "index-module-scss-module__4ObxUa__picture",
  "rounded-user-badge": "index-module-scss-module__4ObxUa__rounded-user-badge",
});
